<script>
export default {
  name: 'BaseModal',
  props: {
    data: Object,
  },
  methods: {
    close(val) {
      this.$emit('close', val)
    },
    cancel(val = false) {
      this.close(val)
    },
    confirm(val = true) {
      this.close(val)
    },
  },
}
</script>
